import { ETheme } from "@/dependencies";
import styled from "styled-components";

export const BlockItemWrapper = styled.div<{ $theme?: ETheme }>`
  display: flex;
  flex-direction: column;
  margin: 0 25px 15px 10px;
  padding-top: 1px;
  box-shadow: var(--shadow4);
  border-radius: 10px;
  .fui-ProgressBar {
    width: calc(100% - 12px);
    margin-left: 6px;
    margin-top: -1px;
  }
`;

export const ItemHeaderWrapper = styled.div<{
  $theme?: ETheme;
  $collapsed?: boolean;
  $isWorking?: boolean;
}>`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  border-radius: ${(props) => (props.$collapsed ? "20px" : "20px 0 0 0")};
  border-left: ${(props) =>
    props.$isWorking
      ? `10px solid var(--colorCompoundBrandBackground) !important`
      : `none`};
`;

export const ContentWrapper = styled.div<{
  $theme?: ETheme;
  $height?: string;
  $isCollapsed?: boolean;
  $initialLoading?: boolean;
}>`
  position: relative;
  max-height: ${(props) =>
    props.$isCollapsed || props.$initialLoading
      ? "0"
      : props.$height
        ? props.$height
        : "calc(100vh - 300px)"};
  opacity: ${(props) => (props.$isCollapsed || props.$initialLoading ? 0 : 1)};
  overflow: auto;
  padding: ${(props) =>
    props.$isCollapsed || props.$initialLoading
      ? "0 30px"
      : "5px 30px 30px 30px"};
  border-top: 1px solid;
  border-color: var(--colorNeutralStroke1);
  transition: all 0.4s cubic-bezier(0.42, 0, 0.58, 1);
`;

export const IconIsCollapsedWrapper = styled.div<{ $isCollapsed?: boolean }>`
  display: flex;
  align-items: center;
  svg {
    transform: ${(props) =>
      props.$isCollapsed ? undefined : "rotate(180deg)"};
    transition: transform 0.4s ease;
  }
`;

export const RightHeaderBase = styled.div`
  display: flex;
`;
